import ColorField, { resolveColor } from './ColorField';

// Icon / tile color (V66, 2026-10-13). Empty = "Same as cover color".
// Unticking starts from the current cover color so the change is visible
// only once the publisher picks something else.
export default function IconColorField({ value, coverValue, onChange, sameLabel = 'Same as cover color' }) {
  const same = !value;
  return (
    <div className="form-field">
      <label>Icon color</label>
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 400, marginBottom: same ? 0 : 8 }}>
        <input type="checkbox" checked={same}
          onChange={(e) => onChange(e.target.checked ? '' : (coverValue || resolveColor(coverValue)))} />
        {sameLabel}
      </label>
      {!same && <ColorField value={value} onChange={onChange} />}
    </div>
  );
}
